import { getTopicDetailQueryOptions } from '@/utils/fetchers/topic'
import { assertTopicRoute } from '@/utils/navigate'
import queryClient from '@/utils/queryClient'
import { createFileRoute } from '@tanstack/react-router'
import TopicPage from './-components/TopicPage'

export const Route = createFileRoute('/topic/$id/$tab/')({
	component: Page,
	loader: async ({ params }) => {
		const topic = await queryClient.ensureQueryData(getTopicDetailQueryOptions(params.id))
		assertTopicRoute(topic, params.tab)

		const hybridURL = topic.tabs.find((item) => item.type === 'hybrid')?.url
		const hybridTopicId = hybridURL && new URL(hybridURL).searchParams.get('topic')

		return {
			data: topic,
			hybridTopicId,
		}
	},
})

function Page() {
	const { id, tab } = Route.useParams()
	const { hybridTopicId } = Route.useLoaderData()

	return <TopicPage id={id} tab={tab} hybridTopicId={hybridTopicId} />
}
